module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-02.0c2a4c54.jpg";